import {
  getExecutionStatusLabel,
  normalizeCargoOperationalState
} from '../routes/execution/statusFacade';

/** Human qty line for dispatcher (places as «т»/мест). */
export function formatQtyPlaces(qty: number, unit = 'т'): string {
  if (!Number.isFinite(qty) || qty <= 0) return '—';
  return `${qty} ${unit}`;
}

export function cargoStateLabel(rawState: string): string {
  return getExecutionStatusLabel(normalizeCargoOperationalState(rawState));
}

export const DRIVER_PLACEHOLDER_LABELS = {
  eta: 'ETA',
  delay: 'Задержка',
  downtime: 'Простой',
  roadside: 'Инцидент на дороге',
  waiting: 'Ожидание'
} as const;
